import { StoreAction, XmAction } from 'store/actions';
import { TradeInOffer, TradeInOfferPromo } from './models';

export function tradeInReducer(state: TradeInOffer[] = [], action: XmAction<TradeInOffer>): TradeInOffer[] {
    let newState: TradeInOffer[];
    switch (action.type) {
        case StoreAction.GET_TRADE_IN_OFFER_DATA:
            newState = state.filter((item: TradeInOffer) => item.offerId !== action.payload.offerId);

            return [ ...newState, action.payload ];
        case StoreAction.CLEAR_TRADE_IN_OFFER_DATA: 
            return undefined;
        default:
            return state;
    }
}

export function tradeInOfferPromoReducer(state: TradeInOfferPromo, action: XmAction<TradeInOfferPromo>): TradeInOfferPromo {
    switch (action.type) {
        case StoreAction.GET_TRADE_IN_OFFER_PROMO:
            return action.payload;
        default:
            return state;
    }
}
